var map = {
	"./1_default.png": "a075",
	"./1_finish.png": "5d9b",
	"./1_selected.png": "582d",
	"./2_default.png": "a2f9",
	"./2_finish.png": "aa6e",
	"./2_selected.png": "712b",
	"./3_default.png": "f38f",
	"./3_finish.png": "bf62",
	"./3_selected.png": "05c4",
	"./but_default.png": "f804",
	"./but_finish.png": "4fdd",
	"./but_selected.png": "4774",
	"./finish_iocn.png": "53090",
	"./map_bg.png": "e57f",
	"./map_select.png": "a15c",
	"./start_button.png": "d3f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e52b";